import { useFeatureFlags } from "@partners/ui";
import {
  useGetUserSuspenseQueryOptions,
  useListFeatureflagsSuspenseQueryOptions,
} from "@partners/ui/api";
import { useSuspenseQueries } from "@tanstack/react-query";
import { useRouterState } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { ProfileMenu } from "@/components/ProfileMenu";

import { AuthenticatedBaseHeader } from "./AuthenticatedBaseHeader";
import { getNavLinks } from "./getNavLinks";
import { ProfileMenuWithTriage } from "./ProfileMenuWithTriageWrapper";

export const AuthenticatedHeaderIBApplicationComplete = () => {
  const { t } = useTranslation();
  const { location } = useRouterState();
  const { subIbCsvExportForMib, referralLinks, performanceReport } =
    useFeatureFlags();

  const [featureflagsQuery, userQuery] = useSuspenseQueries({
    queries: [
      {
        queryKey: useListFeatureflagsSuspenseQueryOptions().queryKey,
        queryFn: useListFeatureflagsSuspenseQueryOptions().queryFn,
        staleTime: 5 * 60 * 1000,
      },
      {
        queryKey: useGetUserSuspenseQueryOptions().queryKey,
        queryFn: useGetUserSuspenseQueryOptions().queryFn,
      },
    ],
  });

  let profileMenu = (
    <ProfileMenu
      onboardingState={userQuery.data.onboardingState}
      isMAMMaster={userQuery.data.isMAMMaster}
      isTriageEnabled={false}
      hasTriagesCompleted={false}
      isIdentityOnlyUser={false}
      userName={userQuery.data.name}
    />
  );

  const showPreOnboardingTriage =
    featureflagsQuery.data.showPreOnboardingTriage?.enabled;

  if (showPreOnboardingTriage) {
    profileMenu = (
      <ProfileMenuWithTriage
        onboardingState={userQuery.data.onboardingState}
        isMAMMaster={userQuery.data.isMAMMaster}
        isIdentityOnlyUser={false}
        userName={userQuery.data.name}
      />
    );
  }

  return (
    <AuthenticatedBaseHeader
      navLinks={getNavLinks(t, {
        showExportReport: subIbCsvExportForMib,
        showPerformanceReport: performanceReport,
        referralLinks,
        showMasterSubIbReport: featureflagsQuery.data.showIBNetworkTab,
      })}
      profileMenuComponent={profileMenu}
      selectedNavLink={location.pathname}
      launchPersonalTradingLinkLabel={t(
        "global_header_launchPersonalTrading_link",
      )}
      isIdentityOnlyUser={false}
    />
  );
};
